"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const MessageAndMediaNotification = ({ children, notificationAttachment, notificationBody, notificationTitle, }) => {
    const renderAttachmentIcon = () => {
        switch (notificationAttachment.type) {
            case 'IMAGE':
                return (React.createElement("img", { src: notificationAttachment.url, style: {
                        height: 32,
                        width: 32,
                        padding: 0,
                        borderRadius: 4,
                        backgroundColor: src_1.titanium,
                        alignSelf: 'flex-end',
                    } }));
            case 'AUDIO':
                return (React.createElement("div", { style: {
                        height: 32,
                        width: 32,
                        padding: 6,
                        borderRadius: 4,
                        backgroundColor: src_1.titanium,
                        alignSelf: 'flex-end',
                    } },
                    React.createElement(src_1.AudioIcon, { fill: src_1.steel, viewBox: "0 0 24 24", height: "20", width: "20" })));
            case 'VIDEO':
            default:
                return (React.createElement("div", { style: {
                        height: 32,
                        width: 32,
                        padding: 6,
                        borderRadius: 4,
                        backgroundColor: src_1.titanium,
                        alignSelf: 'flex-end',
                    } },
                    React.createElement(src_1.VideoIcon, { fill: src_1.steel, viewBox: "0 0 24 24", height: "20", width: "20" })));
        }
    };
    return (React.createElement("div", { style: {
            width: 288,
            minHeight: 128,
            position: 'absolute',
            top: 205,
            left: 16,
        } },
        React.createElement("div", { style: {
                width: 288,
                minHeight: 128,
                backgroundColor: 'white',
                border: `3px solid ${src_1.turquoise}`,
                borderRadius: 8,
                paddingBottom: 20,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                opacity: 0.8,
                flexDirection: 'column',
                alignContent: 'initial',
                overflow: 'hidden',
            } },
            React.createElement("div", { style: {
                    backgroundColor: '#acecf4',
                    height: 45,
                    width: '100%',
                    flex: '0 0 auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '0px 13px',
                } },
                React.createElement("div", { style: {
                        height: 20,
                        width: 20,
                        border: `3px solid ${src_1.turquoise}`,
                        borderRadius: 5,
                    } }),
                React.createElement("div", { style: {
                        height: 4,
                        width: 20,
                        borderRadius: 4,
                        backgroundColor: src_1.turquoise,
                    } })),
            React.createElement(src_1.Text, { size: "small", textStyle: {
                    marginTop: 20,
                    padding: '0 12px',
                    fontWeight: 'bold',
                    width: '100%',
                    flex: 'none',
                }, text: notificationTitle }),
            React.createElement("div", { style: {
                    width: '100%',
                    flex: '1 1 auto',
                    padding: '0px 12px',
                    maxHeight: 24 * 5,
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'space-between',
                } },
                React.createElement(src_1.Text, { size: "small", textStyle: {
                        whiteSpace: 'pre-wrap',
                        overflowWrap: 'break-word',
                        width: '100%',
                    }, text: notificationBody }),
                notificationAttachment && renderAttachmentIcon())),
        children));
};
exports.default = MessageAndMediaNotification;
